const config = {
    algolia_app_id: '72IIWD41XZ',
    algolia_search_api_key: 'd267eabf877b9b64daf9f593903dd681',
    algolia_index_name: 'prod_practices'
}
export default config;